var InvitedList = [
  {
      id: 0,
      name: 'Mohan Sridharan',
      image: 'Mohan',
      affiliation: 'The University of Edinburgh',
      link: 'https://homepages.inf.ed.ac.uk/msridhar/',
    },
    {
      id: 1,
      name: 'Mark Keane',
      image: 'MarkKeane',
      affiliation: 'University College Dublin',
      link: 'https://people.ucd.ie/mark.keane',
    }
];


var OrganizingTeamList = [
  {
    id: 1,
    name: 'Benjamin Krarup',
    image: 'ben',
    affiliation: 'Kings College London',
    link: 'https://scholar.google.co.uk/citations?user=yEjXNsQAAAAJ&hl=en',
  },
  {
    id: 2,
    name: 'Alan Lindsay',
    image: 'alanL',
    affiliation: 'Simplifai Systems',
    link: 'http://tinyurl.com/AlanLindsayScholar',
  },
  {
    id: 3,
    name: 'Silvia Tulli',
    image: 'silvia',
    affiliation: 'Sorbonne University',
    link: 'https://silviatulli.com/',
  },
  {
    id: 4,
    name: 'Stylianos Vasileiou',
    image: 'stylianos',
    affiliation: 'New Mexico State University',
    link: 'https://thestlucas.com/',
  },
  {
    id: 5,
    name: 'Chenyuan Zhang',
    image: 'chenyuan',
    affiliation: 'Monash University',
    link: 'https://sites.google.com/view/chenyuanzhang',
  },
];

var SteeringCommitteeList = [
  {
    id: 8,
    name: 'Jeremy Frank',
    image: 'frank',
    affiliation: 'NASA',
    link: 'https://www.linkedin.com/in/jeremy-frank-62141bb3/',
  },
  {
    id: 9,
    name: 'Claudia Goldman',
    image: 'claudia',
    affiliation: 'The Hebrew University of Jerusalem',
    link: 'https://claudiagoldman.huji.ac.il/',
  },
  {
    id: 10,
    name: 'Jörg Hoffmann',
    image: 'joerg',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/hoffmann/',
  },
  {
    id: 11,
    name: 'Subbarao Kambhampati',
    image: 'rao',
    affiliation: 'Arizona State University',
    link: 'https://rakaposhi.eas.asu.edu/',
  },
  {
    id: 6,
    name: 'David Smith',
    image: 'david',
    affiliation: 'PS Research',
    link: 'http://psresearch.xyz/',
  },
  {
    id: 7,
    name: 'William Yeoh',
    image: 'william',
    affiliation: 'Washington University in St. Louis',
    link: 'https://sites.wustl.edu/wyeoh/',
  },
];

var PCList = [
  {
    id: 0,
    name: 'Pulkit Verma',
    affiliation: 'Indian Institute of Technology Madras, India',
  },
   {
    id: 1,
    name: 'Pascal Bercher',
    affiliation: 'Australian National University, Australia',
  },
  {
    id: 2,
    name: 'Daniel Gnad',
    affiliation: 'Heidelberg University, Germany and Linköping University, Sweden',
  },
    {
    id: 3,
    name: 'Shashank Shekhar',
    affiliation: 'University of Caen Normandy, France',
  },
   {
    id: 4,
    name: 'Ron Petrick',
    affiliation: 'Heriot-Watt University, UK',
  },
  {
    id: 5,
    name: 'Emanuele De Pellegrin',
    affiliation: 'Heriot-Watt University, UK',
  },
      {
    id: 6,
    name: 'Victoria Armstrong',
    affiliation: 'Queen’s University, Canada',
  },
   {
    id: 7,
    name: 'Emile Siboulet',
    affiliation: 'LAAS-CNRS, France and Safran Electronics & Defense, France',
  },
  {
    id: 8,
    name: 'Rachid Alami',
    affiliation: 'LAAS-CNRS, France and Safran Electronics & Defense, France',
  }
];


export {
  OrganizingTeamList,
  SteeringCommitteeList,
  PCList,
  InvitedList,
  //PanelList,
};
